// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Home from "./component/Home";
import About from "./component/About";
import Header from "./component/Header";
import Footer from "./component/Footer";
import NotFound from "./NotFound";
import Profile from "./component/Profile";
import Price from "./component/Price";
import Cart from "./component/Cart";
import AdminPanel from "./component/AdminPanel";
import Soglashenie from "./component/Soglashenie";
import Warranty from "./component/Warranty";


// Важно:
// - После успешного логина где-нибудь в компоненте логина вызови:
//   import { setTokens } from './utils/authFetch';
//   setTokens({ access: data.access, refresh: data.refresh });
// - При выходе из аккаунта вызови:
//   import { clearTokens } from './utils/authFetch';
//   clearTokens();

function App() {
  return (
    // <GoogleReCaptchaProvider reCaptchaKey="...">
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/price" element={<Price />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/adminpanel" element={<AdminPanel />} />
            <Route path="/Soglashenie" element={<Soglashenie />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    // </GoogleReCaptchaProvider>
  );
}

export default App;
